import { render, staticRenderFns } from "./RelAuster.vue?vue&type=template&id=51f62726&scoped=true&"
import script from "./RelAuster.vue?vue&type=script&lang=js&"
export * from "./RelAuster.vue?vue&type=script&lang=js&"
import style0 from "./RelAuster.vue?vue&type=style&index=0&id=51f62726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f62726",
  null
  
)

export default component.exports